// Path: ./src/app/components/LinkComponent/index.tsx
import * as React from "react";
import styled from "styled-components";
import {
  PathMatch,
  useMatch,
  useNavigate,
  useResolvedPath,
} from "react-router-dom";

interface Props {
  title: React.ReactNode;
  cssStyle?: string;
  pathTo: string;
  dataTestId?: string;
}

interface LinkCompProps {
  cssStyle?: string;
  isActive?: PathMatch<string> | null;
}
const LinkComp = styled.div<LinkCompProps>`
  width: 100%;
  padding-left: 15px;
  border-bottom: ${(props) => (props?.isActive ? "3px solid #ee8129" : "0px")};
  padding-top: 15px;
  color: "white";
  cursor: pointer;
  font-size: 18px;
  text-transform: capitalize;
  ${(props) => props?.cssStyle}
`;

export function LinkComponent(props: Props) {
  const { title, pathTo } = props;
  const navigate = useNavigate();
  const resolved = useResolvedPath(pathTo);
  const match = useMatch({ path: resolved.pathname, end: true });
  /**
   * Handles navigation to a specific path using the provided path parameter.
   * @param path The target path to navigate to.
   */
  const handleNavigate = (path: string) => {
    navigate(path);
  };

  return (
    <LinkComp
      onClick={() => {
        handleNavigate(pathTo);
      }}
      isActive={match}
      data-testid={props?.dataTestId}
    >
      {title}
    </LinkComp>
  );
}
